import Loading from '../../Common/Loading';
import { useEstablishmentLocationChartsDataContext } from './hooks/useEstablishmentLocationChartsDataContext';
import { LocationTopCnes } from './LocationTopCnes';
import { ManagementByYear } from './ManagementByYear';
import { TopMunicipalities } from './TopMunicipalities';
import { TopMunicipalitiesMap } from './TopMunicipalitiesMap';
import { LocationByNature } from './LocationByNature';
import '../Common/Styles/Ciha.css'

export const Charts = () => {
    const { isLoading } = useEstablishmentLocationChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-map-table-ciha">
                <TopMunicipalitiesMap />
                <TopMunicipalities />
            </div>
            <div className="charts-side-by-side-dashboards">
                <ManagementByYear />
                <LocationByNature />
            </div>
  
        </>
    );
};
